import { Link } from "react-router-dom";
import useAutoHoverAnimation from '../../hooks/useAutoHoverAnimation';

export default function HeroBanner() {
    const titleRef = useAutoHoverAnimation(100, 100, 600);

    return (
        <>
            <div id="hero">
                <div id="hero-video-background">
                    <img src="/images/courses-banner/course-piano-banner.jpg" alt="Guitar Hero" />
                </div>
                <div id="hero-styles">
                    <div id="hero-caption" className="height-title content-full-width text-align-center parallax-scroll-caption">
                        <div className="inner">
                            <h1 ref={titleRef} className="hero-title caption-timeline primary-font-title">
                                <div>
                                    <span>P</span>
                                    <span>I</span>
                                    <span>A</span>
                                    <span>N</span>
                                    <span>O</span>
                                    <span>/</span>
                                    <span>K</span>
                                    <span>E</span>
                                    <span>Y</span>
                                    <span>B</span>
                                    <span>O</span>
                                    <span>A</span>
                                    <span>R</span>
                                    <span>D</span>
                                </div>
                            </h1>
                            <div className="hero-cta">
                                <Link to="/admission-form" className="cta-button">ENROLL NOW</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
} 